import React, { Component } from "react";
import { withRouter } from "react-router";
import AuthService from "../session/AuthService.js";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Taskicon from "../images/job.png";
import serviceIcons from "../images/note-alt.png";
import EquipmentIcons from "../images/hammer-drill.png";
import EmployeeIcons from "../images/user-7.png";
import vehiclesIcons from "../images/tractor-2.png";
import BuildingsIcons from "../images/home-alt-1.png";
// import notificatinIcons from "../images/notification-bell.png";
// import PaymentIcons from "../images/money-bag-dollar.png";
import TaskIconActive from "../images/jobactive.png";
import serviceIconsActive from "../images/note-alt-active.png";
import EmployeeIconsActive from "../images/user-7-active.png";
//  import notificatinIconsActive from "../images/notification-bell-active.png"
import EquipmentIconsActive from "../images/hammer-drill-active.png";
import vehiclesIconsActive from "../images/tractor-2-active.png";
import BuildingsIconsActive from "../images/home-alt-1-active.png";
import AdminEmployeeIcons from "../images/adminEmployee.svg";
import AdminEmployeeIconsActive from "../images/adminEmployeeActive.svg";
import { Icon } from "@iconify/react";
import { NavLink } from "react-bootstrap";
// import { Badge } from "@mui/material";
import FarmShopConnectLogo from "../images/FarmShopConnectLogo.png";
import FarmSuperAdminLogo from "../images/farmAdminLogo.svg";
import { Tooltip } from "antd";

class NavigationsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem:
        parseInt(AuthService.getUserTypeAdmin()) === 3
          ? "Employers"
          : "Employee",
      // activeItem: "Employee",
      totalCount: 0,
      screenWidth: window.innerWidth,
    };
  }

  componentDidMount() {
    this.setState(
      {
        activeItem: AuthService.getactiveMarkers(),
      },
      () => {
        console.log("getactiveMarkers", AuthService.getactiveMarkers());
        console.log("getactiveMarkers", this.state.activeItem);
      }
    );
  }

  toggleSidebar = () => {
    this.setState((prevState) => ({
      sidebarCollapsed: !prevState.sidebarCollapsed,
    }));
  };

  handleItemClick = (itemName) => {
    this.setState({ activeItem: itemName }, () => {
      AuthService.storeActiveMarkers(this.state.activeItem);
      this.props.history.replace(this.state.activeItem);
    });
  };

  funcHomeRedirect = () => {
    this.props.history.replace("/Employee");
    this.setState(
      {
        activeItem: "Employee",
      },
      () => {
        AuthService.storeActiveMarkers(this.state.activeItem);
      }
    );
  };

  funcHomeRedirect2 = () => {
    this.props.history.replace("/Employers");
    this.setState(
      {
        activeItem: "Employers",
      },
      () => {
        AuthService.storeActiveMarkers(this.state.activeItem);
      }
    );
  };

  logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Logout?",
      icon: "warning",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        AuthService.removeAuth();
        // AuthService.storeLanguageList("en");
        this.props.history.push("/");
      }
    });
  };

  render() {
    console.log("in render Notification data", this.props.NotificationData);
    const auth = AuthService.isAuth();

    const { activeItem } = this.state;

    const imageSrc =
      activeItem === "Buildings" ? BuildingsIconsActive : BuildingsIcons;
    const imageSrc1 =
      activeItem === "vehicles" ? vehiclesIconsActive : vehiclesIcons;

    const userType = parseInt(AuthService.getUserTypeAdmin()); // Assuming getUserType returns the user type

    let rootStyleObj = document.documentElement.style;
    if (userType === 1) {
      rootStyleObj.setProperty("--user-based-color01", "#f9f9f9");
      rootStyleObj.setProperty("--user-based-color02", "#000000");
      rootStyleObj.setProperty("--green-or-black", "#8abc49");
      rootStyleObj.setProperty("--pagination", "#d8f6b2");
    } else {
      rootStyleObj.setProperty("--user-based-color01", "#000000");
      rootStyleObj.setProperty("--user-based-color02", "#ffffff");
      rootStyleObj.setProperty("--green-or-black", "#000000");
      rootStyleObj.setProperty("--pagination", "#d3d3d3");
    }
    // alert(userType)

    console.log(
      "AuthType::boo",
      parseInt(AuthService.getUserTypeAdmin()) === 1
    );
    console.log(
      "AuthType::getUserTypeAdmin",
      typeof AuthService.getUserTypeAdmin()
    );
    console.log("AuthType::AuthService", AuthService.getUserTypeAdmin());

    const className = "";
    // userType === 1 ? "small-box-parent" : "small-box-parent-2";

    return (
      <>
        {auth && (
          <>
            <nav id="nav-sidebar">
              {/* <GiHamburgerMenu style={{float : "right"}} onClick={this.ChangeSize}/> */}
              {this.props.menuState && (
                <>
                  <div className="d-flex justify-content-between flex-column h-100">
                    <div>
                      <div className="logo-container">
                        <img
                          src={
                            userType === 1
                              ? FarmShopConnectLogo
                              : FarmSuperAdminLogo
                          }
                          alt="Logo"
                          className="logo-navbar cursor-pointer"
                          onClick={
                            userType === 1
                              ? this.funcHomeRedirect
                              : this.funcHomeRedirect2
                          }
                        />
                      </div>
                      {userType === 1 ? (
                        <ul className="navbar-items">
                          <li
                            className={`navbar-item ${
                              activeItem === "Employee" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/Employee"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("Employee")}
                            >
                              <img
                                src={
                                  activeItem === "Employee"
                                    ? EmployeeIconsActive
                                    : EmployeeIcons
                                }
                                alt="EmployeeIcons"
                                id="navabricon1"
                              />{" "}
                              <span>Employee</span>
                            </NavLink>
                          </li>
                          <li
                            className={`navbar-item ${
                              activeItem === "Equipment" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/Equipment"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("Equipment")}
                            >
                              <img
                                src={
                                  activeItem === "Equipment"
                                    ? EquipmentIconsActive
                                    : EquipmentIcons
                                }
                                alt="EquipmentIcons"
                                id="navabricon1"
                              />{" "}
                              <span>Equipment</span>
                            </NavLink>
                          </li>
                          <li
                            className={`navbar-item ${
                              activeItem === "Buildings" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/Buildings"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("Buildings")}
                            >
                              <img
                                src={imageSrc}
                                alt="BuildingsIcons"
                                id="navabricon1"
                              />{" "}
                              <span>Building</span>
                            </NavLink>
                          </li>
                          <li
                            className={`navbar-item ${
                              activeItem === "vehicles" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/vehicles"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("vehicles")}
                            >
                              <img
                                src={imageSrc1}
                                id="navabricon1"
                                alt="vehiclesIcons"
                              />{" "}
                              <span>Vehicle</span>
                            </NavLink>
                          </li>
                          <li
                            className={`navbar-item ${
                              activeItem === "Services" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/services"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("Services")}
                            >
                              <img
                                src={
                                  activeItem === "Services"
                                    ? serviceIconsActive
                                    : serviceIcons
                                }
                                alt="ServiceIcons"
                                id="navabricon1"
                              />{" "}
                              <span>Services Records</span>
                            </NavLink>
                          </li>
                          <li
                            className={`navbar-item ${
                              activeItem === "Tasks" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/Tasks"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("Tasks")}
                            >
                              <img
                                src={
                                  activeItem === "Tasks"
                                    ? TaskIconActive
                                    : Taskicon
                                }
                                alt="Taskicon"
                                id="navabricon1"
                              />{" "}
                              <span>Tasks</span>
                            </NavLink>
                          </li>
                          {/* <li
                      className={`navbar-item ${
                        activeItem === "Notifications" ? "active" : ""
                      }`}
                    >
                      <NavLink
                        to="/Notifications"
                        activeClassName="active"
                        onClick={() => this.handleItemClick("Notifications")}
                      >
                        <Badge badgeContent={this.props.NotificationData.totalCount} color="primary">
                        <img
                          src={ activeItem === "Notifications" ?  notificatinIconsActive : notificatinIcons}
                            
                          alt="notificatinIcons"
                          id="navabricon1"
                        />{" "} 
                       </Badge>
                       
                    
                         <span style={{paddingLeft : "8px"}}>Notification</span>  
                      </NavLink>
                    </li> */}
                          {/* <li
                        className={`navbar-item ${
                          activeItem === "Payments" ? "active" : ""
                        }`}
                      >
                        <NavLink
                          to="/Payments"
                          activeClassName="active"
                          onClick={() => this.handleItemClick("Payments")}
                        >
                          <img
                            src={PaymentIcons}
                            alt="PaymentIcons"
                            id="navabricon1"
                          />
                          Payments
                        </NavLink>
                      </li> */}
                          <li
                            className={`navbar-item ${
                              activeItem === "Activity" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/Activity"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("Activity")}
                            >
                              {/* <img
                          src={ activeItem === "Activity" ?  notificatinIconsActive : notificatinIcons}
                            
                          alt="notificatinIcons"
                          id="navabricon1"
                        />{" "} */}

                                <Icon
                                  icon="bi:activity"
                                  color= {activeItem === "Activity" ? "green" : "black"} 
                                  width={22}
                                  height={22}
                                  id="logo-in-nav"
                                />
                              

                              <span style={{ marginLeft: "7px" }}>
                                Activity
                              </span>
                            </NavLink>
                          </li>
                          <li
                            className={`navbar-item ${
                              activeItem === "safety-notification" ? "active" : ""
                            }`}
                          >
                            <NavLink
                              to="/safety-notification"
                              activeClassName="active"
                              onClick={() => this.handleItemClick("safety-notification")}
                            >

                                <Icon
                                  icon="bi:wrench-adjustable-circle"
                                  color= {activeItem === "safety-notification" ? "green" : "black"}
                                  width={22}
                                  height={22}
                                  id="logo-in-nav"
                                />
                

                              <span style={{ marginLeft: "7px" }}>
                              Alerts
                              </span>
                            </NavLink>
                          </li>
                        </ul>
                      ) : (
                        <>
                          <ul className="navbar-items">
                            <li
                            className="navbar-item navbar-admin"
                              // className={`navbar-item ${
                              //   activeItem === "Employers" ? "active" : ""
                              // }`}
                            >
                              <NavLink
                                // to="/Employee"
                                activeClassName="active"
                                onClick={() =>
                                  this.handleItemClick("Employers")
                                }
                              >
                                <img
                                  src={
                                    activeItem === "Employers"
                                      ? AdminEmployeeIconsActive
                                      : AdminEmployeeIcons
                                  }
                                  alt="EmployeeIcons"
                                  id="navabricon1"
                                  width="15px"
                                />{" "}
                                <span>Employers</span>
                              </NavLink>
                            </li>
                            <li
                              className="navbar-item navbar-admin"
                            >
                              <NavLink
                                // to="/Admin-Employee"
                                activeClassName="active"
                                onClick={() => this.handleItemClick("Admin-Employee")}
                              >
                                <img
                                  src={
                                    activeItem === "Admin-Employee"
                                      ? AdminEmployeeIconsActive
                                      : AdminEmployeeIcons
                                  }
                                  alt="EmployeeIcons"
                                  id="navabricon1"
                                  width="15px"
                                />{" "}
                                <span>Employees</span>
                              </NavLink>
                            </li>
                          </ul>
                        </>
                      )}
                    </div>
                    <div className="m-2">
                      <div className="small-box">
                        <ul className="small-box-list">
                          {/* <NavLink
                      to="/editprofile"
                      activeClassName="active"
                      onClick={() => this.handleItemClick("editprofile")}
                    >
                     
                     Settings
                    </NavLink> */}

                          <NavLink
                            to="/editprofile"
                            activeClassName="active"
                            onClick={() => this.handleItemClick("editprofile")}
                          >
                            <i class="fa fa-user" aria-hidden="true"></i>
                            <span style={{ marginLeft: "10px" }}>Profile</span>
                          </NavLink>
                          <li
                            className="small-box-item"
                            onClick={this.logout}
                            activeClassName="active"
                          >
                            <i class="fa fa-sign-out" aria-hidden="true"></i>
                            <span style={{ marginLeft: "10px" }}>Logout</span>
                          </li>
                        </ul>
                      </div>
                      {userType === 1 && (
                        <div class="footer-query mt-2 fs-7 text-center p-1">
                          <p className="m-0">Having any issues?</p>
                          <p className="m-0">
                            Contact us at{" "}
                            <Tooltip title="support@farmshopconnect.com">
                              <span>
                                <a
                                  className="forgot-password-text fs-7"
                                  href="mailto:support@farmshopconnect.com"
                                >
                                  support@farmshopconnect.com
                                </a>
                              </span>{" "}
                            </Tooltip>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </nav>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = function (state) {
  console.log("state in redux recive", state);
  return {
    NotificationData: state.selectedProfile.NotificationData,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(NavigationsMenu)));
